import { logoutUser } from '@carvana/core-auth';
import * as types from './types';
import { signInStatus } from '@utilities/afterSignInSuccess';

export const fetchTradeSuccess = trade => ({
  type: types.FETCH_TRADE_SUCCESS,
  trade
});

export const fetchTradeInProgress = isInProgress => ({
  type: types.FETCH_TRADE_IN_PROGRESS,
  isInProgress
});

// note(oscar): discounts actions

export const getDiscountsLoading = () => ({
  type: types.GET_DISCOUNTS_LOADING
});

export const getDiscountsSuccess = data => {
  const { content } = data;
  const { discounts } = content || {};
  return {
    type: types.GET_DISCOUNTS_SUCCESS,
    discounts
  };
};

export const getDiscountsError = error => ({
  type: types.GET_DISCOUNTS_ERROR,
  error
});

export const logOut = () => async ({ onSuccess }) => {
  logoutUser(() => {
    [
      'deviceInformation',
      'PartnerId',
      'PartnerKey',
      'PartnerObject',
      'PartnerVanityUrlName',
      'PartnerWhisperNumber',
    ].forEach(k => {
      localStorage.removeItem(k);
    });

    signInStatus.setSignedIn(false);

    if (onSuccess) onSuccess();

    if (window.location.href.includes('my-carvana')) {
      window.location.href = window.location.origin;
      return;
    }

    window.location.reload();
  });
};

export const requestProfile = () => ({
  type: types.REQUEST_PROFILE,
});

// todo(oscar): move to an operation and simplify action, but first replace all usages
export const requestProfileSuccess = profile => {
  return {
    type: types.REQUEST_PROFILE_SUCCESS,
    payload: profile
  };
};

export const requestProfileError = error => ({
  type: types.REQUEST_PROFILE_ERROR,
  payload: error
});

export const setFavorites = favorites => ({
  type: types.SET_FAVORITES,
  favorites
});

export const setAccountUrls = useModalUrlForAccountLinks => ({
  type: types.SET_ACCOUNT_URLS,
  payload: useModalUrlForAccountLinks
});

export const setGeolocation = geolocation => ({
  type: types.SET_GEOLOCATION,
  geolocation
});

export const setAppSettings = appSettings => ({
  type: types.SET_APP_SETTINGS,
  appSettings
});

export const setIsInDotCom = isInDotCom => ({
  type: types.SET_IS_IN_DOT_COM,
  payload: isInDotCom
});

export const setCampaignPromotions = () => ({
  type: types.SET_CAMPAIGN_PROMOTIONS
});

export const fetchShouldFireHeaderEventablePageLoadEventBegin = () => ({
  type: types.FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_BEGIN,
});
export const fetchShouldFireHeaderEventablePageLoadEventSuccess = eventableFeatureFlag => ({
  type: types.FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_SUCCESS,
  payload: eventableFeatureFlag
});
export const fetchShouldFireHeaderEventablePageLoadEventFailure = error => ({
  type: types.FETCH_SHOULD_FIRE_HEADER_EVENTABLE_PAGE_LOAD_EVENT_FAILURE,
  payload: error
});
